module.exports = __webpack_public_path__ + "static/img/light.0f82724.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/UST/light.png
// module id = H62e
// module chunks = 3